var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFanmaumTextLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 48,
    viewBox: "0 0 142 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3540_25277)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.7192 1.11307C30.2372 -0.984931 25.9352 0.272069 23.2952 1.70007C16.9532 5.12307 15.9942 11.6941 15.9242 14.8391C12.7792 14.9091 6.20816 15.8681 2.78516 22.2101C0.197158 26.9941 1.03616 31.6041 2.19516 34.6311C3.56016 38.1951 6.18816 41.5431 9.22516 43.5891C14.5812 47.1931 20.1682 48.0011 24.9272 47.9991C26.0342 47.9991 27.0962 47.9561 28.0992 47.8941C29.9512 47.7791 31.8212 47.5301 33.6062 47.2111C35.1922 46.9301 35.4412 44.7611 33.9552 44.1361C33.6662 44.0161 33.3502 43.9831 33.0442 44.0361C31.3722 44.3351 29.6262 44.5661 27.9012 44.6741C22.7912 44.9901 16.7902 44.7891 11.0272 40.9121C6.68516 37.9881 1.96416 30.5091 5.61816 23.7371C8.37616 18.6321 13.9462 18.0551 16.3132 18.0551C16.5312 18.0551 16.7222 18.0601 16.8832 18.0651C17.4902 18.0901 18.0882 17.8591 18.5172 17.4271C18.9462 16.9951 19.1802 16.4001 19.1552 15.7931C19.0772 13.9131 19.2482 7.54307 24.8272 4.53407C31.5992 0.877069 39.0782 5.59807 42.0052 9.94007C45.0242 14.4231 45.8122 19.0481 45.8682 23.2871C45.8782 24.0581 46.4052 24.7451 47.1612 24.8961C48.1702 25.0991 49.1042 24.3241 49.0912 23.3051C49.0312 18.6641 48.1552 13.2961 44.6842 8.13807C42.6382 5.10107 39.2882 2.47307 35.7262 1.10807L35.7192 1.11307Z",
    fill: "url(#paint0_linear_3540_25277)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.938 29.2912L25.095 36.2462C25.025 36.8262 24.739 37.3552 24.332 37.7522C24.292 37.7952 24.249 37.8352 24.201 37.8702C24.025 38.0062 23.804 38.0862 23.566 38.0862C23.237 38.0862 22.944 37.9352 22.75 37.7022C22.163 36.9922 21.232 36.5802 20.21 36.7262C18.983 36.9022 18.006 37.9162 17.873 39.1512C17.72 40.5692 18.644 41.8012 19.926 42.1332H19.931C20.483 42.2712 21.063 42.3412 21.658 42.3412C22.991 42.3412 24.238 41.9802 25.31 41.3522C25.343 41.3322 25.375 41.3122 25.405 41.2942C27.21 40.2372 28.552 38.3672 28.811 36.2442L29.775 28.3182C29.825 27.8942 30.187 27.5782 30.613 27.5782H32.654C33.681 27.5782 34.614 26.7452 34.74 25.7182C34.865 24.6912 34.133 23.8582 33.106 23.8582H31.271C30.764 23.8582 30.372 23.4162 30.433 22.9122L31.472 14.3732C31.542 13.7862 31.836 13.2512 32.253 12.8522C32.278 12.8272 32.303 12.8042 32.331 12.7792C32.514 12.6312 32.748 12.5432 32.999 12.5432C33.315 12.5432 33.601 12.6812 33.792 12.9042C33.802 12.9142 33.812 12.9242 33.82 12.9342C34.39 13.6222 35.291 14.0232 36.277 13.9082C37.529 13.7602 38.538 12.7462 38.681 11.4912C38.844 10.0652 37.918 8.82618 36.63 8.49218H36.625C36.073 8.35618 35.493 8.28418 34.898 8.28418C33.585 8.28418 32.358 8.63518 31.299 9.24518C29.424 10.2872 28.019 12.1942 27.755 14.3732L26.691 23.1152C26.638 23.5392 26.279 23.8552 25.853 23.8552H23.913C22.886 23.8552 21.953 24.6882 21.827 25.7152C21.702 26.7422 22.434 27.5752 23.461 27.5752H25.198C25.705 27.5752 26.097 28.0172 26.036 28.5212L25.943 29.2922L25.938 29.2912Z",
    fill: "url(#paint1_linear_3540_25277)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.6249 28.7569C79.2899 28.7569 77.9969 29.1789 76.8799 29.8909C76.8569 29.9059 76.8319 29.9209 76.8099 29.9359C76.5209 30.1269 76.2429 30.3349 75.9819 30.5609C75.7689 30.3179 75.5329 30.0939 75.2769 29.8929C75.2389 29.8629 75.2019 29.8349 75.1669 29.8079C74.2679 29.1429 73.1309 28.7539 71.8489 28.7539C70.7949 28.7539 69.7659 29.0179 68.8299 29.4789C68.5509 29.0399 68.0589 28.7559 67.4619 28.7539C66.4349 28.7539 65.4669 29.6529 65.3209 30.6819L64.7089 35.0119L64.4299 36.9749L64.0889 39.3949L64.0439 39.7109C63.8909 40.7829 64.7039 41.7689 65.7709 41.8619C65.8239 41.8699 65.8759 41.8699 65.9319 41.8699C66.8229 41.8699 67.5629 41.2299 67.6889 40.3519L67.7369 40.0109L67.8249 39.3989L68.4349 35.0869C68.6279 33.7319 69.8329 32.5649 71.1959 32.4969C72.6539 32.4269 73.6879 33.5839 73.4879 35.0139L73.1989 37.0649L72.9979 38.4759C72.8369 39.6029 73.7409 40.6339 74.8849 40.6339C75.7759 40.6339 76.5189 39.9939 76.6419 39.1129L76.8049 37.9659L76.9329 37.0619L77.2119 35.0869C77.4049 33.7319 78.6099 32.5649 79.9729 32.4969C81.4309 32.4239 82.4699 33.5809 82.2669 35.0139L81.6469 39.3959L81.5889 39.7929V39.7979C81.4939 40.8369 82.2869 41.7759 83.3259 41.8609C83.3789 41.8689 83.4309 41.8689 83.4869 41.8689C84.3809 41.8689 85.1209 41.2289 85.2459 40.3509L85.2939 40.0019L85.3789 39.3949L85.9989 35.0129C86.4859 31.5669 84.0809 28.7579 80.6329 28.7579L80.6249 28.7569Z",
    fill: "url(#paint2_linear_3540_25277)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.484 28.7569C134.149 28.7569 132.856 29.1789 131.739 29.8909C131.716 29.9059 131.691 29.9209 131.669 29.9359C131.38 30.1269 131.102 30.3349 130.841 30.5609C130.628 30.3179 130.392 30.0939 130.136 29.8929C130.098 29.8629 130.061 29.8349 130.026 29.8079C129.127 29.1429 127.991 28.7539 126.708 28.7539C125.654 28.7539 124.625 29.0179 123.689 29.4789C123.41 29.0399 122.918 28.7559 122.321 28.7539C121.294 28.7539 120.326 29.6529 120.18 30.6819L119.568 35.0119L119.289 36.9749L118.948 39.3949L118.903 39.7109C118.752 40.7829 119.563 41.7689 120.63 41.8619C120.683 41.8699 120.735 41.8699 120.791 41.8699C121.682 41.8699 122.422 41.2299 122.548 40.3519L122.596 40.0109L122.684 39.3989L123.294 35.0869C123.487 33.7319 124.692 32.5649 126.055 32.4969C127.513 32.4269 128.547 33.5839 128.347 35.0139L128.058 37.0649L127.857 38.4759C127.696 39.6029 128.6 40.6339 129.744 40.6339C130.635 40.6339 131.378 39.9939 131.501 39.1129L131.664 37.9659L131.792 37.0619L132.071 35.0869C132.264 33.7319 133.469 32.5649 134.832 32.4969C136.29 32.4239 137.329 33.5809 137.126 35.0139L136.506 39.3959L136.448 39.7929V39.7979C136.353 40.8369 137.146 41.7759 138.185 41.8609C138.238 41.8689 138.29 41.8689 138.346 41.8689C139.24 41.8689 139.98 41.2289 140.105 40.3509L140.153 40.0019L140.238 39.3949L140.858 35.0129C141.345 31.5669 138.94 28.7579 135.492 28.7579L135.484 28.7569Z",
    fill: "url(#paint3_linear_3540_25277)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.175 28.6309C115.159 28.6309 114.215 29.4569 114.072 30.4759L113.317 35.8249C113.094 37.4109 111.618 38.7009 110.032 38.7009C108.446 38.7009 107.336 37.4109 107.56 35.8249L108.315 30.4759C108.458 29.4599 107.75 28.6309 106.734 28.6309C105.718 28.6309 104.774 29.4569 104.631 30.4759L103.876 35.8249C103.364 39.4439 105.894 42.3879 109.513 42.3879C113.132 42.3879 116.493 39.4439 117.005 35.8249L117.76 30.4759C117.903 29.4599 117.195 28.6309 116.179 28.6309H116.175Z",
    fill: "url(#paint4_linear_3540_25277)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.24 28.6641C99.5122 28.6641 98.8853 29.0911 98.6112 29.7261C97.6823 29.0681 96.5232 28.6871 95.2232 28.6871C91.6092 28.6871 88.2532 31.6291 87.7412 35.2431C87.2292 38.8571 89.7542 41.7991 93.3682 41.7991C94.7532 41.7991 96.1012 41.3651 97.2662 40.6271C97.5502 41.3151 98.2302 41.8221 99.0282 41.8221C99.9192 41.8221 100.662 41.1821 100.785 40.3041L102.125 30.8241C102.283 29.7001 101.382 28.6681 100.24 28.6681V28.6641ZM97.5752 35.2421C97.3192 37.0521 95.6403 38.5221 93.8333 38.5221C92.0262 38.5221 90.7612 37.0511 91.0172 35.2421C91.2732 33.4351 92.9523 31.9641 94.7593 31.9641C96.5663 31.9641 97.8312 33.4351 97.5752 35.2421Z",
    fill: "url(#paint5_linear_3540_25277)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.098 28.541C44.338 28.541 43.687 29.008 43.436 29.688C42.51 29.038 41.358 28.661 40.065 28.661C36.451 28.661 33.095 31.603 32.583 35.217C32.071 38.831 34.596 41.773 38.21 41.773C39.613 41.773 40.978 41.329 42.153 40.573C42.452 41.226 43.112 41.697 43.885 41.697C44.776 41.697 45.519 41.057 45.642 40.179L46.982 30.699C47.14 29.575 46.239 28.543 45.097 28.543L45.098 28.541ZM42.418 35.217C42.162 37.027 40.483 38.497 38.676 38.497C36.869 38.497 35.604 37.026 35.86 35.217C36.116 33.41 37.795 31.939 39.602 31.939C41.409 31.939 42.674 33.41 42.418 35.217Z",
    fill: "url(#paint6_linear_3540_25277)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.616 28.546C55.406 28.546 54.224 28.875 53.167 29.445C52.831 28.91 52.236 28.541 51.556 28.541C50.665 28.541 49.922 29.181 49.799 30.059L49.131 34.785C49.106 34.91 49.083 35.033 49.066 35.161L48.406 39.829C48.275 40.755 48.84 41.521 49.704 41.669C49.9 41.739 50.113 41.779 50.334 41.779C51.225 41.779 51.968 41.139 52.091 40.261L52.844 34.938C53.17 33.455 54.578 32.28 56.092 32.28C57.681 32.28 58.793 33.573 58.567 35.161L57.907 39.829C57.761 40.861 58.479 41.696 59.508 41.696C60.537 41.696 61.493 40.86 61.639 39.829L62.299 35.161C62.814 31.514 60.266 28.545 56.619 28.545L56.616 28.546Z",
    fill: "url(#paint7_linear_3540_25277)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3540_25277",
    x1: -2.75224,
    y1: 14.8066,
    x2: 238.338,
    y2: 91.7668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#FE6669"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FEB2B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FEE2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEF5F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3540_25277",
    x1: -2.92488,
    y1: 15.3516,
    x2: 238.163,
    y2: 92.3118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#FE6669"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FEB2B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FEE2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEF5F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3540_25277",
    x1: -5.14897,
    y1: 10.172,
    x2: 235.939,
    y2: 87.1321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#FE6669"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FEB2B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FEE2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEF5F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3540_25277",
    x1: 0.362876,
    y1: -5.58189,
    x2: 241.451,
    y2: 71.3808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#FE6669"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FEB2B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FEE2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEF5F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3540_25277",
    x1: -1.17083,
    y1: -0.774946,
    x2: 239.917,
    y2: 76.1878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#FE6669"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FEB2B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FEE2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEF5F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3540_25277",
    x1: -2.80047,
    y1: 3.54677,
    x2: 238.29,
    y2: 80.507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#FE6669"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FEB2B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FEE2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEF5F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3540_25277",
    x1: -4.57285,
    y1: 20.5114,
    x2: 236.515,
    y2: 97.4716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#FE6669"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FEB2B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FEE2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEF5F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3540_25277",
    x1: -3.41996,
    y1: 16.8972,
    x2: 237.671,
    y2: 93.8574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#FE6669"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FEB2B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FEE2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEF5F5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3540_25277"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 142,
    height: 48,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFanmaumTextLogo);
export default __webpack_public_path__ + "static/media/FanmaumTextLogo.9748138ee60bed9d4cc78f5e1c015270.svg";
export { ForwardRef as ReactComponent };